import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface SubscriptionEndDateState {
  endDate: string;
}

const subscriptionEndDate: Module<SubscriptionEndDateState, RootState> = {
  namespaced: true,
  state: {
    endDate: '',
  } as SubscriptionEndDateState,
  mutations: {
    setValue(state: SubscriptionEndDateState, value: string): void {
      state.endDate = value;
    },
  },
};

export default subscriptionEndDate;
